<link
  rel="stylesheet"
  href="https://js.arcgis.com/4.11/esri/themes/light/main.css"
  />

  <div class="map-container">
    <div id="legend" #legend class="legend">
      <ul>
        @for (layer of allLayers; track layer) {
          <li class="legendItem">
            <input type="checkbox" class="no-margin-bottom" value="{{layer.id}}" [checked]="layer.visible" [disabled]="!layer.enabled" (change)="selectedChanged(layer.id)"/>
            <label [ngClass]="{disabled: !layer.enabled}">{{layer.title}} </label>
          </li>
        }
      </ul>
    </div>
    <div id="wellViewerNode" #wellViewerNode class="wellViewerNode" style="z-index: 500">
    </div>
  </div>